import { debounce } from '@theme/utilities'

/**
 * A custom element that allows the user to search items.
 */

class SearchInputComponent extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('[data-search-input]');
    this.items = Array.from(this.querySelectorAll('[data-search-result-item]'));
    this.filters = Array.from(this.querySelectorAll('[data-search-filter]'));
    this.counter = this.querySelector('[data-search-counter]');
    this.noResults = this.querySelector('[data-search-no-results]');

    this.filters?.forEach(filter => filter.addEventListener('click', () => this.apply()));
    this.onInput = debounce(() => this.apply(), 100);
  }

  connectedCallback() {
    if (!this.input) return;
    this.input.addEventListener('input', this.onInput);
    this.apply(); // initial (in case input has value)
  }

  disconnectedCallback() {
    this.input?.removeEventListener('input', this.onInput);
    this.filters?.forEach(filter => filter.removeEventListener('click', this.apply));
  }

  apply() {
    const inputValue = (this.input.value || '').trim().toLowerCase();
    const selectedFilter = this.querySelector('.filter-type:checked');
    const selectedValue = selectedFilter?.value || 'All';
    let showingItems = 0;

    //filtering
    this.items?.forEach((el) => {
      const title = (el.dataset.title || '').trim().toLowerCase();
      const matchesSearch = !inputValue || title.includes(inputValue);
      const matchesFilter = selectedValue.includes('All') || el.dataset.type === selectedValue;

      el.dataset.match = matchesSearch ? 'true' : 'false';
      if(matchesSearch && matchesFilter) showingItems += 1;
    })

    //results
    const total = Number(this.counter?.dataset.searchCounterTotal || this.items?.length);
    if(showingItems === 0) {
      this.counter.innerHTML = 'No results found';
    } else if(showingItems == total) {
      this.counter.innerHTML = `Showing all ${showingItems} products`;
    } else {
      this.counter.innerHTML = `Showing ${showingItems} of ${total} products`;
    }

    showingItems === 0 ? this.noResults?.classList.remove('hidden') : this.noResults?.classList.add('hidden');
  }
}

if (!customElements.get('search-input-component')) {
  customElements.define('search-input-component', SearchInputComponent);
}